import { themeColors } from '../styles/theme'

export const ENQUEUE_NOTIFICATION = 'ENQUEUE_NOTIFICATION'
export const notify = notification => ({
  type: ENQUEUE_NOTIFICATION,
  payload: {
    clickaway: true,
    timeout: 2000,
    ...notification,
  },
})

export const notifySuccess = notification =>
  notify({
    ...notification,
    style: {
      backgroundColor: themeColors.positive,
    },
  })
export const notifyFailure = notification =>
  notify({
    ...notification,
    style: {
      backgroundColor: 'red',
    },
  })

export const DEQUEUE_NOTIFICATION = 'DEQUEUE_NOTIFICATION'
export const dequeueNotification = () => ({
  type: DEQUEUE_NOTIFICATION,
})



// WEBPACK FOOTER //
// ./src/actions/notificationQueue.js